export type BlobLike = {
  readonly size: number
  readonly type: string
  readonly slice: (start?: number, end?: number) => BlobLike
  readonly arrayBuffer: () => Promise<ArrayBuffer>
  readonly arrayBufferSync: () => ArrayBuffer
  readonly createObjectURL: () => Promise<string>
}

export type BlobArrayLike = {
  slice: (start?: number, end?: number) => BlobArrayLike
  push: (inputs: BlobInput) => void
  clear: () => void

  blobs: BlobLike[]
  offsets: number[]
  size: number
} & Omit<BlobLike, "size" | "slice">

export type BlobInputSimple = ArrayBuffer | Blob | string | Uint8Array

export type BlobInputSingle = BlobArrayLike | BlobInputSimple | BlobLike

export type BlobInput = BlobInputSingle | BlobInputSingle[]
